"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyticsService = void 0;
const key_1 = require("@/app/shared/helpers/storage/constants/key");
const hubSpotEventsService_1 = require("@/app/shared/services/hubSpotEventsService");
const postHogService_1 = require("@/app/shared/services/postHogService");
class AnalyticsService {
    constructor() {
        Object.defineProperty(this, "initialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    init() {
        if (this.initialized)
            return;
        postHogService_1.postHogService.initialize();
        hubSpotEventsService_1.hubSpotEventsService.initialize();
        this.initialized = true;
    }
    identify(email) {
        if (!this.initialized)
            return;
        postHogService_1.postHogService.identify(email);
        hubSpotEventsService_1.hubSpotEventsService.identify(email);
    }
    reset() {
        if (!this.initialized)
            return;
        postHogService_1.postHogService.reset();
    }
    getCommonProperties() {
        const properties = {};
        const integration = localStorage.getItem(key_1.StorageKey.INTEGRATION);
        if (integration) {
            properties.integration = integration.toLowerCase();
        }
        const params = new URLSearchParams(window.location.search);
        const extensionIntegration = params.get('extensionIntegration');
        properties.platform = extensionIntegration === 'OUTLOOK' ? 'outlook_addin' : 'chrome_extension';
        return properties;
    }
    trackFeatureActionPerformed(actionType, extraProperties) {
        if (!this.initialized)
            return;
        const properties = { ...this.getCommonProperties(), ...extraProperties };
        postHogService_1.postHogService.capture('feature_action_performed', {
            feature_id: 'meeting_booker',
            action_type: actionType,
            ...properties,
        });
        hubSpotEventsService_1.hubSpotEventsService.trackFeatureActionPerformed('meeting_booker', actionType);
        if (actionType.endsWith('_inserted') || actionType.endsWith('_copied')) {
            postHogService_1.postHogService.capture('feature_adopted', {
                feature_id: 'meeting_booker',
                ...properties,
            });
            hubSpotEventsService_1.hubSpotEventsService.trackFeatureAdopted('meeting_booker');
            postHogService_1.postHogService.setOnce({ meeting_booker_adopted_at: new Date().toISOString() });
        }
    }
    trackDialogOpened() {
        this.trackFeatureActionPerformed('meeting_booker_dialog_opened');
    }
    trackSpotsInserted() {
        this.trackFeatureActionPerformed('meeting_booker_spots_inserted');
    }
    trackLinkCopied() {
        this.trackFeatureActionPerformed('meeting_booker_link_copied');
    }
    trackGuestsInserted() {
        this.trackFeatureActionPerformed('meeting_booker_guests_inserted');
    }
    trackDialogClosed() {
        this.trackFeatureActionPerformed('meeting_booker_dialog_closed');
    }
    trackAuthCompleted() {
        this.trackFeatureActionPerformed('meeting_booker_auth_completed');
    }
}
exports.analyticsService = new AnalyticsService();
